import { render, staticRenderFns } from "./BigMoments.vue?vue&type=template&id=54594865&scoped=true&"
import script from "./BigMoments.vue?vue&type=script&lang=js&"
export * from "./BigMoments.vue?vue&type=script&lang=js&"
import style0 from "./BigMoments.vue?vue&type=style&index=0&id=54594865&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54594865",
  null
  
)

export default component.exports